import { render, staticRenderFns } from "./purchaseOrderTask.vue?vue&type=template&id=59762731&scoped=true"
import script from "./purchaseOrderTask.vue?vue&type=script&lang=js"
export * from "./purchaseOrderTask.vue?vue&type=script&lang=js"
import style0 from "./purchaseOrderTask.vue?vue&type=style&index=0&id=59762731&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59762731",
  null
  
)

export default component.exports